import { render, staticRenderFns } from "./DashboardFilters.vue?vue&type=template&id=6050711d&scoped=true&"
import script from "./DashboardFilters.vue?vue&type=script&lang=ts&"
export * from "./DashboardFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardFilters.vue?vue&type=style&index=0&id=6050711d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050711d",
  null
  
)

export default component.exports